import Rub from '@shared/svg/rub.svg'
import Star from '@shared/svg/star.svg'

export const partnerFormSummary = [
	{
		Icon: Star,
		content: 'Быстро решите жилищный вопрос',
	},
	{
		Icon: Rub,
		content: 'Получите ипотеку по выгодным условиям с комфортным ежемесячным платежом',
	},
]
